<template>
  <div class="grid-view">
    <template v-if="staff && !empty(staff)">
      <div class="alert-hover"></div>
      <div class="sidebar col sticky-top" :class="collapsed ? 'sm' : ''">
        <div class="sidebar-header text-center">
          <img class="img" :src="currentOrganization ? currentOrganization.logo : ''" />
        </div>
        <nav class="nav flex-column sidebar-menu" v-if="currentOrganization && staff && !empty(staff)">
          <router-link class="nav-link" :to="{ name: 'organizations' }" v-if="can('read_organizations')">
            <div class="nav-logo"><i class="fa fa-sitemap"></i></div>
            <div class="nav-link-text">{{ 'organizations' | t | titlecase }}</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'customers' }" v-if="can('read_customers')">
            <div class="nav-logo"><i class="fa fa-users"></i></div>
            <div class="nav-link-text">{{ 'customers' | t | titlecase }}</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'order_channels' }" v-if="can('read_order_channels')">
            <div class="nav-logo"><i class="fa fa-desktop"></i></div>
            <div class="nav-link-text">{{ 'order_channels' | t | titlecase }}</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'carriers' }" v-if="can('read_carriers')">
            <div class="nav-logo"><i class="fa fa-truck"></i></div>
            <div class="nav-link-text">{{ 'carriers' | t | titlecase }}</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'order_channel_types' }" v-if="can('read_order_channel_types')">
            <div class="nav-logo"><i class="fa fa-plug"></i></div>
            <div class="nav-link-text">{{ 'order_channel_types' | t | titlecase }}</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'carrier_types' }" v-if="can('read_carrier_types')">
            <div class="nav-logo"><i class="fa fa-truck"></i></div>
            <div class="nav-link-text">{{ 'carrier_types' | t | titlecase }}</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'user_groups' }" v-if="can('read_user_groups')">
            <div class="nav-logo"><i class="fa fa-id-card-o"></i></div>
            <div class="nav-link-text">{{ 'user_groups' | t | titlecase }}</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'barcode_ranges' }" v-if="can('read_global_barcode_ranges')">
            <div class="nav-logo"><i class="fa fa-barcode"></i></div>
            <div class="nav-link-text">{{ 'global_barcode_ranges' | t | titlecase }}</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'oauth_applications' }" v-if="can('write_oauth_applications')">
            <div class="nav-logo"><i class="fa fa-puzzle-piece"></i></div>
            <div class="nav-link-text">{{ 'oauth_applications' | t | titlecase }}</div>
          </router-link>
          <router-link
            class="nav-link"
            :to="{ name: 'invoices' }"
            v-if="can('read_customers') && !managed_organization"
          >
            <div class="nav-logo"><i class="fa fa-file-text-o"></i></div>
            <div class="nav-link-text">{{ 'invoices' | t | titlecase }}</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'plans' }" v-if="can('read_plans') && !managed_organization">
            <div class="nav-logo"><i class="fa fa-money"></i></div>
            <div class="nav-link-text">{{ 'plans' | t | titlecase }}</div>
          </router-link>
          <router-link
            class="nav-link"
            :to="{ name: 'products' }"
            v-if="can('read_purchases') && !managed_organization"
          >
            <div class="nav-logo"><i class="fa fa-gift"></i></div>
            <div class="nav-link-text">{{ 'products' | t | titlecase }}</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'payment_terms' }" v-if="can('read_payment_terms')">
            <div class="nav-logo"><i class="fa fa-calendar-check-o"></i></div>
            <div class="nav-link-text">{{ 'payment_terms' | t | titlecase }}</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'automations' }" v-if="can('read_automations')">
            <div class="nav-logo"><i class="fa fa-magic"></i></div>
            <div class="nav-link-text">Automations</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'mail_templates' }" v-if="can('read_mail_templates')">
            <div class="nav-logo"><i class="fa fa-envelope-o"></i></div>
            <div class="nav-link-text">Mail templates</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'mail_builders' }" v-if="can('read_mail_templates')">
            <div class="nav-logo"><i class="fa fa-envelope-o"></i></div>
            <div class="nav-link-text">Mail builders</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'error_messages' }" v-if="can('read_error_messages')">
            <div class="nav-logo"><i class="fa fa-ban"></i></div>
            <div class="nav-link-text">Error Messages</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'zipcode_formats' }" v-if="can('write_carrier_types')">
            <div class="nav-logo"><i class="fa fa-map-marker"></i></div>
            <div class="nav-link-text">Zipcode formats</div>
          </router-link>
          <router-link
            class="nav-link"
            :to="{ name: 'capabilities' }"
            v-if="can('read_carrier_types') && can('read_order_channel_types')"
          >
            <div class="nav-logo"><i class="fa fa-plug"></i></div>
            <div class="nav-link-text">Capabilities</div>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'white_label_reports' }" v-if="can('read_white_label_reports')">
            <div class="nav-logo"><i class="fa fa-file-text-o"></i></div>
            <div class="nav-link-text">{{ 'reports' | t | titlecase }}</div>
          </router-link>
        </nav>
        <div class="sidebar-collapse" @click="collapsed = !collapsed">
          <i class="fa fa-angle-right fa-2x" :class="collapsed ? '' : 'fa-flip-horizontal'"></i>
        </div>
      </div>
      <div v-if="staff && !empty(staff) && currentOrganization">
        <div class="main-content" style="position: relative">
          <div class="sticky-top">
            <nav class="navbar navbar-light bg-white shadowed breadcrumb mb-0 px-5">
              <a class="nav-link pl-0 text-bolder"
                ><span v-for="(breadcrumb, i) in breadcrumbs"
                  ><span class="fa fa-angle-right px-2" v-if="i > 0"></span>
                  <router-link :to="breadcrumb.to">{{ breadcrumb.text }}</router-link></span
                ></a
              >
              <div class="form-inline ml-auto" v-if="staff">
                <div class="nav-item dropdown small">
                  <a class="nav-link dropdown-toggle" data-toggle="dropdown"> {{ staff.email }}</a>
                  <div class="dropdown-menu">
                    <template v-if="can('read_staffs')">
                      <router-link class="dropdown-item" :to="{ name: 'staffs' }">{{
                        'staff_accounts' | t
                      }}</router-link>
                      <div class="dropdown-divider"></div> </template
                    ><a class="dropdown-item" @click="logout">{{ 'sign_out' | t }}</a>
                  </div>
                </div>
                <i class="fa fa-bell"></i>
              </div>
            </nav>
          </div>
          <router-view></router-view>
        </div>
      </div>
    </template>
    <div class="col col-auth full-span" v-else>
      <div class="row h-100">
        <div class="col">
          <div class="row no-gutters">
            <div class="col sidebar sticky-top" :class="collapsed ? 'sm' : ''">
              <div class="sidebar-header text-center">
                <div class="img"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col h-100">
          <div class="d-flex h-100 align-items-center justify-content-center">
            <div class="div w-100">
              <authentication></authentication>
            </div>
          </div>
        </div>
        <div class="col"></div>
      </div>
    </div>
    <!-- footer-->
  </div>
</template>

<script>
// / Load Components
import store from '@/store';
import { mapState } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';

export default {
  computed: {
    ...mapState(['token', 'errors', 'breadcrumbs']),
    managed_organization() {
      let org = this.currentOrganization;
      if (org) {
        return org.is_managed;
      } else {
        true;
      }
    }
  },
  data: function () {
    return {
      collapsed: false
    };
  },
  methods: {
    empty: function (o) {
      return _.isEmpty(o);
    },
    logout: function () {
      this.$store.commit('setToken', '');
      this.$store.commit('setRefreshToken', null);
    }
  },
  components: {},
  store
};
</script>

<style scoped>
.grid-view {
  display: grid;

  grid-template-columns: auto minmax(0, 1fr);
}

.full-span {
  grid-column: span 2;
}
</style>
